<script>
import {mapActions, mapGetters, mapMutations, mapState} from "vuex";

export default {
  name: "TheActionTitlePortfolio",

  data() {
    return {
      edit_loading: false,
      isSomeHoverOpen: false,
    };
  },

  computed: {
    ...mapState({
      competition: state => state.scholarship_competition?.competition?.competition?.competition,
    }),

    ...mapGetters({
      isStudentsRoleIncludes: "portfolio/isStudent",
    }),

  },

  methods: {
    ...mapMutations({
      setEditMode: 'scholarship_competition/setEditMode',
    }),

    ...mapActions({
      openDialogSelection: 'scholarship_competition/setDialogAction',
      editCompetitionApplication: 'scholarship_competition/editCompetitionApplication',
      setDialogAction: 'achievement/setDialogAction',
    }),

    editCompetition(id) {
      this.edit_loading = true;
      this.editCompetitionApplication(id)
        .then(() => {
          this.setEditMode(true);
          this.openDialogSelection(true);
        })
        .finally(() => this.edit_loading = false);
    },

  },

}
</script>

<template>
<div>
  <v-hover v-slot="{ hover }">
    <v-btn
      small
      elevation="0"
      :color="$store.state.achievement.side_color"
      href = "/portfolio"
      class="white--text old-portfolio-btn rounded-xl"
      target="_blank"
    >
      <v-icon small color="white" :left="hover && !$vuetify.breakpoint.mobile">
        fa fa-suitcase
      </v-icon>
      <v-expand-x-transition>
        <div v-if="hover && !$vuetify.breakpoint.mobile">Cтарое портфолио</div>
      </v-expand-x-transition>
    </v-btn>
  </v-hover>

  <v-hover v-slot="{ hover }">
    <v-btn
      elevation="4"
      :color="$store.state.achievement.side_color"
      @click="setDialogAction(true)"
      class="rounded-xl white--text"
      small
    >
      <v-icon :small="!hover" left>fa-plus-circle</v-icon>
      <v-expand-x-transition>
        <div class="on-hover-description">Добавить достижение</div>
      </v-expand-x-transition>
    </v-btn>
  </v-hover>

</div>
</template>

<style scoped>
.on-hover-description {
  transition: opacity .4s ease-in-out;
}
</style>